import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let Chart3DRowsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-chart3d-rows';
        }
    }
});
export const Chart3DRowsPlugin = {
    name: 'e-chart3d-rows',
    install(Vue) {
        Vue.component(Chart3DRowsPlugin.name, Chart3DRowsDirective);
    }
};
export let Chart3DRowDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-chart3d-row';
        }
    }
});
export const Chart3DRowPlugin = {
    name: 'e-chart3d-row',
    install(Vue) {
        Vue.component(Chart3DRowPlugin.name, Chart3DRowDirective);
    }
};
